module.exports = __webpack_public_path__ + "static/media/icon-proficincy.9585240c.svg";